import { PartialTableColumnType, TableColumnType } from '@ui';

export const applySortableValues = (
  columns: TableColumnType[] | PartialTableColumnType[],
  sortableColumnKeys: string[],
): TableColumnType[] => {
  return columns.map((column: TableColumnType | PartialTableColumnType) => ({
    ...column,
    isSortable: sortableColumnKeys.includes(column.key),
  }));
};
